export const SEARCH_RESULTS_SUMMARY_ID = "search-result-count";
